export default __webpack_public_path__ + "locales/pl/PeopleTranslations.json?hash=854fca06592802d51aefd1821317faf7";